import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import { useQueryState, useResponsive } from '@dustin-web/microsite-components/src/hooks'
import { useEffect, useState } from 'react'
import classNames from 'classnames'
import { ActiveFilters } from './active-filters'
import { FacetGroup } from '.'
import { FilterBox } from './filter-box'
import { Filters } from './filters'

type Props = {
  facets: FacetGroup[]
  totalHits?: number
  onClearFilter: () => void
  onClose?: () => void
}

export const FacetList = ({ facets, totalHits = 0, onClearFilter, onClose }: Props) => {
  const { translate } = useI18n()
  const { isSmallScreen } = useResponsive()
  const { queryState } = useQueryState()
  const [hasActiveFilters, setHasActiveFilters] = useState(false)
  const { activeFilters: filtersFromUser } = queryState

  useEffect(() => {
    // don't count 'pageUri' and 'page'
    const filters = filtersFromUser.filter(f => f.name !== 'pageUri' && f.name !== 'page')
    setHasActiveFilters(filters.length > 0)
  }, [queryState])

  return facets.length > 0 ? (
    <>
      <FilterBox
        className="u-flex-1 u-overflow-auto"
        title={translate('mobilefilterlabel')}
        additionalTopContent={
          <button
            className={classNames('button-stripped p-sm u-mb-0', {
              'd-none': isSmallScreen,
            })}
            onClick={onClearFilter}
            disabled={!hasActiveFilters}>
            {translate('ResetAllFilters')}
          </button>
        }
        activeFilters={
          isSmallScreen ? <ActiveFilters facetGroups={facets} mobile={isSmallScreen} /> : null
        }>
        <Filters facets={facets} />
      </FilterBox>
      {isSmallScreen && (
        <div className="c-filter-footer u-px-16 u-py-16 d-flex" style={{ zIndex: 10 }}>
          <button
            className="c-btn u-mb-0 u-w-shrink"
            disabled={!hasActiveFilters}
            onClick={() => onClearFilter()}>
            {translate('ResetAllFilters')}
          </button>
          <button
            className="c-btn c-btn--primary u-flex-1 u-mb-0 u-bg-white u-color-black"
            onClick={() => onClose && onClose()}>
            {translate(
              hasActiveFilters ? 'MobileCloseAndShowProductsFilterLabel' : 'MobileCloseLabel',
              { count: totalHits }
            )}
          </button>
        </div>
      )}
    </>
  ) : null
}
